import { SET_QA, SET_QA_CONDITIONS, SET_QA_ANSWERS } from './actionTypes'
import { QaActionTypes, IAnswer } from './types'

const initialState = {
    interestedNext: '',
    colour: '',
    answers: [
      {
        key: "planOnReplacing",
        Question: "Are you planning on replacing your car after selling it? (Your Instant Offer will not change based on your response)",
        Value: 0
      }
    ],
    conditions: {}
}

export default (state = initialState, action: QaActionTypes) => {
  switch (action.type) {
    case SET_QA:
      return { ...state, ...action.payload }
    case SET_QA_CONDITIONS: 
      return {...state, conditions: {...state.conditions, ...action.payload} };
    case SET_QA_ANSWERS: 
    const a = state.answers;
      Object.keys(action.payload).forEach((k) => {
        a.map((o: any) => {
          if (o.key == k){
            o.Value = (action.payload as any)[k];
            return o;
          }
        });
      });
      return {...state, answers: a };
    default:
      return state;
  }
}
